// Configuration centralisée des CGU
export const CGU_CONFIG = {
  CURRENT_VERSION: '1.0',
  LAST_UPDATE: '4 septembre 2025',
  
  // Historique des versions pour référence
  VERSION_HISTORY: [
    {
      version: '1.0',
      date: '4 septembre 2025',
      changes: [
        'Version initiale des CGU',
        'Définition des services Nodemented',
        'Politique de confidentialité et données',
        'Conditions d\'utilisation et responsabilités'
      ]
    }
    // Futures versions à ajouter ici
  ]
};

// Fonction pour comparer les versions
export const isVersionOutdated = (userVersion, currentVersion = CGU_CONFIG.CURRENT_VERSION) => {
  if (!userVersion) return true;
  
  // Conversion en nombres pour comparaison (ex: "1.0" -> 1.0, "1.1" -> 1.1)
  const userVersionNum = parseFloat(userVersion);
  const currentVersionNum = parseFloat(currentVersion);
  
  return userVersionNum < currentVersionNum;
};

// Fonction pour obtenir les changements depuis une version
export const getChangesSince = (fromVersion) => {
  const fromVersionNum = parseFloat(fromVersion || '0.0');
  
  return CGU_CONFIG.VERSION_HISTORY
    .filter(v => parseFloat(v.version) > fromVersionNum)
    .map(v => ({
      version: v.version,
      date: v.date,
      changes: v.changes
    }));
};

export default CGU_CONFIG;
